"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isDataExport(object) {
    return checkDataExport(object).fulfilled;
}
exports.isDataExport = isDataExport;
function checkDataExport(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("projectId"), __1.hasString("userId")).withOptions(options).explain();
}
exports.checkDataExport = checkDataExport;
//# sourceMappingURL=DataExport.js.map